import Vue from 'vue'
import * as types from './mutation-types'

const namespaced = true

const getterKeys = {
    'senate': 'senateList',
    'senateRunoff': 'senateRunoffList',
    'house': 'houseList',
}

const initialState = {
    houseList: [],
    senateList: [],
    senateRunoffList: [],
}

const mutations = {
    [types.PUT_LANDING_MODELS](state, { models, key }) {
        state[key] = models
            .sort((a, b) => b.date - a.date)
            .map(model => ({
                ...model,
                chamber: model.election.chamber
            }))
    },
    [types.CLEAR_MODELS](state, key) {
        Vue.set(state, key, [])
    }
}

const actions = {
    putCongressionalList: async ({commit}, { params, key }) => {
        const url = params.chamber === "SENATE" ? "https://forecasting-data.decisiondeskhq.com/2022/prod/senate_models.json" : "https://forecasting-data.decisiondeskhq.com/2022/prod/house_models.json";

        await fetch(url)
            .then((response) => {
                if (!response.ok) {
                    throw new Error(response.status);
                }

                return response.json();
            })
            .then((data) => {
                const getterKey = getterKeys[key]
                commit(types.CLEAR_MODELS, getterKey)
                commit(types.PUT_LANDING_MODELS, { models: data.sort((a, b) => b.date - a.date), key: getterKey })
                return data
            })
            .catch((error) => {
                // eslint-disable-next-line
                console.error(error);
            })
    },
}

const getters = {
    houseList(state) {
        return state.houseList
    },
    senateList(state) {
        return state.senateList
    },
    senateRunoffList(state) {
        return state.senateRunoffList
    },
}

export default {
    namespaced,
    state: initialState,
    mutations,
    actions,
    getters
}
